import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/truck.svg")